import axios from "axios";
import request from "./request";

const req = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'https://vrhouse.qujkj.com/api',
  timeout: 10000
});

request(req);

export default req;
